'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPagesService = function () {
  function ProductPagesService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductPagesService);
    this.api = Api;
  }

  (0, _createClass3.default)(ProductPagesService, [{
    key: 'loadCategories',
    value: function loadCategories(data) {
      return this.api.call({
        method: 'get',
        url: '/productPage/categories/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
      });
    }
  }, {
    key: 'loadCategoriesNoLimit',
    value: function loadCategoriesNoLimit(parentId) {
      return this.api.call({
        method: 'get',
        url: '/productPage/categoriesNoLimit/' + parentId
      });
    }
  }, {
    key: 'getProductPage',
    value: function getProductPage(id, type) {
      return this.api.call({
        method: 'get',
        url: '/productPage/get/' + id + '/' + type
      });
    }
  }, {
    key: 'getProductPageProducts',
    value: function getProductPageProducts(id, type) {
      return this.api.call({
        method: 'get',
        url: '/productPage/products/' + id + '/' + type
      });
    }
  }, {
    key: 'saveProductPage',
    value: function saveProductPage(data) {
      var url = '/productPage/saveProductPage';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateProductPage',
    value: function updateProductPage(data, type) {
      var url = '/productPage/updateProductPage/' + type;
      return this.api.call({
        method: 'put',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'loadProductPages',
    value: function loadProductPages(data, type) {
      return this.api.call({
        method: 'get',
        url: '/productPage/list/' + data.categoryId + '/' + data.subCategoryId + '/' + data.currentPage + '/' + data.pageLimit + '/' + type + '/' + data.field + '/' + data.order_type
      });
    }
  }, {
    key: 'saveCategory',
    value: function saveCategory(data) {
      var url = '/productPage/saveCategory';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateCategoryOrder',
    value: function updateCategoryOrder(data) {
      var url = '/productPage/updateCategoryOrder';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateProductPageOrder',
    value: function updateProductPageOrder(data) {
      var url = '/productPage/updateProductPageOrder';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(id, type) {
      var url = '/productPage/removeCategory/' + id + '/' + type;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'categoryById',
    value: function categoryById(id) {
      return this.api.call({
        method: 'get',
        url: '/productPage/category/' + id
      });
    }
  }, {
    key: 'updateCategory',
    value: function updateCategory(data) {
      var url = '/productPage/updateCategory';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getSubCategory',
    value: function getSubCategory(data) {
      return this.api.call({
        method: 'get',
        url: '/productPage/getSubCategory/' + data.parentId + '/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
      });
    }
  }, {
    key: 'updateProductPageStatus',
    value: function updateProductPageStatus(data) {
      var url = '/productPage/updateStatus';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeProductPage',
    value: function removeProductPage(id) {
      var url = '/productPage/removeProductPage/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'removeProduct',
    value: function removeProduct(id, apid) {
      var url = '/productPage/removeProduct/' + id + '/' + apid;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }]);
  return ProductPagesService;
}();

// WEBPACK FOOTER //


exports.default = ProductPagesService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/services/products.pages.service.js
 **/